export const environment = {
  name:'dev',
  production: false,
  apiURL: 'https://dev.betsio.fr',
  apiSecureURL: 'https://dev.betsio.fr/s',
  defaultURL: 'https://dev.adm.betsio.fr'
};
